import EventEmitter from 'events';
import ZoneSelector from './ZoneSelector';

const MULTI_ZONE_SEPARATOR = '-';

class ZoneSelectorCollection extends EventEmitter {
  /**
   * @param {HTMLElement} container
   * @param {string} selectedZoneId
   */
  constructor(container, selectedZoneId = null) {
    super();

    const zoneSelectorContainers = Array.from(container.querySelectorAll('.tn-ticket-selector__zone-selector'));

    let selectedZoneIds;

    if (selectedZoneId !== null) {
      selectedZoneIds = selectedZoneId.split(MULTI_ZONE_SEPARATOR);
    } else {
      selectedZoneIds = Array(zoneSelectorContainers.length).fill(null);
    }

    this.zoneSelectors = zoneSelectorContainers.map((el, index) => {
      const zoneSelector = new ZoneSelector(
        el,
        selectedZoneIds[index],
      );

      zoneSelector.on('update', this.onZoneUpdate);

      return zoneSelector;
    });
  }

  onZoneUpdate = () => {
    this.emit('update', this.getSelectedZoneId());
  }

  getSelectedZoneId() {
    const ids = this.zoneSelectors.map(zoneSelector => zoneSelector.getSelectedZoneId());

    if (ids.length === 1) {
      return ids[0];
    }

    if (ids.includes(null)) {
      return null;
    }

    return ids.join(MULTI_ZONE_SEPARATOR);
  }

  destroy() {
    this.removeAllListeners();

    this.zoneSelectors.forEach(zoneSelector => zoneSelector.destroy());
  }
}


export default ZoneSelectorCollection;



// WEBPACK FOOTER //
// ./V7/events/detail/ZoneSelectorCollection.js